import { useEffect, useState } from "react";
import { liveDetect } from '@/services/user/security.ts'
import {useAsyncEffect} from "ahooks";
import {getToken} from "@/redux/slices/user";
import { enqueueSnackbar } from "notistack"
import {useTranslation} from "react-i18next";


function useRiskCheck() {
  const { t } = useTranslation();
  const [risk, setRisk] = useState({});

  useAsyncEffect(async () => {
    if (getToken()) {
      try {
        const risk = await liveDetect();
        setRisk(risk);
      } catch (error) {
        enqueueSnackbar(error.msg || t("user_risk_exception"), { variant: 'error' })
      }
    }

  }, []);

  return {risk};
}

export default useRiskCheck;